import { put, select, takeLatest } from 'redux-saga/effects';
import { setLanguageFilter } from 'actions/platformUsage/actions';
import { getLocale } from './selectors';
import { updateMenu } from 'actions/auth/login';

/*** Fetch Users ***/
// Worker
export function* changeLanguageWorker() {
  const locale = yield select(getLocale);
  yield put(updateMenu());
  yield put(setLanguageFilter(locale));
}

// Watcher
export function* changeLanguageSaga() {
  yield takeLatest('REDUX_I18N_SET_LANGUAGE', changeLanguageWorker);
}



// WEBPACK FOOTER //
// ./src/actions/language/languageSagas.js